import React from 'react'
import {
  AU as au,
  BR as br,
  CA as ca,
  DE as de,
  DK as dk,
  ES as es,
  FI as fi,
  FR as fr,
  GB as gb,
  IN as india,
  IT as it,
  MX as mx,
  NO as no,
  SE as se,
  US as us,
} from 'country-flag-icons/react/3x2'

const FLAGS = {
  se,
  no,
  it,
  de,
  ca,
  gb,
  es,
  au,
  fr,
  fi,
  dk,
  br,
  mx,
  in: india,
  global: us,
}

const MarketFlag = ({ market }) => {
  if (!market || !market.id) {
    return null
  }

  const Flag = FLAGS[market.id]

  if (!Flag) {
    return <span>{market.emoji}</span>
  }

  return <Flag />
}

export default MarketFlag
